import React, { useState } from "react";
import { GetQuestionDisplay, formatDateWithTime, generateGUID } from "../utils/utils";
import { AdminViewHistory, InterviewObject, Question, SessionQuestion } from "@/utils/types";
import { useAppContext } from "../appContext";
import Nav from "./nav";
import TrackSessionQuestion from "./TrackSessionQuestion";
import { AutoAwesome, ScoreOutlined, TaskAlt, TimelineOutlined } from "@mui/icons-material";
import AdminMemberInfoBreadCrumb from "./AdminMemberInfoBreadCrumb";

interface HistoryScreenProps {
  AttemptedQuestionSelected?: (question: string, index: number | null) => void;
  adminViewInfo?: AdminViewHistory;
}

function HistoryScreen(props: HistoryScreenProps) {
  const [showTrend, setShowTrend] = useState(false);
  const { state, reducers, navigateThenRun, showPastFeedback } = useAppContext();

  const {
    setloading,
    setprompt,
    setshowFeedback,
    setshowHistoryModal,
    setdisplayPastFeedback,
    setpastInfo,
    setsession,
    setcurrentQuestion,
    setretryPast,
  } = reducers;


  function getAttemptedQuestions() {
    var cont: JSX.Element[] = [];
    let questions: string[] = [];
    if (questions1) {
      questions = Object.keys(questions1);
    }
    for (let i = 0; i < questions.length; i++) {
      const que= questions[i];
      cont[i] = (
        <React.Fragment key={`q${generateGUID()}`}>
          {/* TODO: UPDATE FOR STARS */}
          <TrackSessionQuestion
          showCheckbox = {false}
            question={{ //this is a pseudo question
              question: {
                question: que,
                domain: "",
                level: "",
                specType: questions1?.[que][0].specType ?? "",
                subCategories: [],
                type: "",
              },
              difficulty: "General",
              noOfStars: questions1?.[que][questions1?.[que].length - 1].stars||0,//from recent attempt
              selected: false,
              tag: questions1?.[que][0].specType ?? "",
              tagColor: "text-[#000]",
            }}
            dropDownOptions={questions1![que].slice().reverse().map((q, i) => ({
              label:
                "timestamp" in q
                  ? formatDateWithTime(
                    q["timestamp"].slice(0, q["timestamp"].lastIndexOf(":"))
                  )
                  : `${i}`,
              value: `${i}`,
              parent: que,
              noOfStars: q["stars"]||0,
            }))}
            setSelectedQuestions={() => { }}
            navigate={(e:string, i:string) => { AttemptedQuestionSelected!(e, Number(i))}}
          />
          {/* <div className={`wrapper displayquestionBank2`}>
            <p>{GetQuestionDisplay(questions[i], null)}</p>
            <div className="dropdown">
              <select
                id="dropdown"
                defaultValue={-1}
                onChange={(e) => {
                  AttemptedQuestionSelected!(questions[i], Number(e.target.value));
                }}
              >
                <option disabled value={-1}>
                  Date and Time
                </option>
                {questions1![questions[i]].map((x, ind) => (
                  <option key={generateGUID()} value={ind}>
                    {"timestamp" in x
                      ? x["timestamp"].slice(0, x["timestamp"].lastIndexOf(':'))
                      : ind}
                  </option>
                ))}
              </select>
            </div>
          </div> */}
        </React.Fragment>
      );
    }
    return cont.reverse();
  }

  const questions1 = !props.adminViewInfo
    ? state.profileUser && state.profileUser.answeredQuestions
      ? state.profileUser.answeredQuestions
      : {}
    : props.adminViewInfo.studentInfo.answeredQuestions;

  const AttemptedQuestionSelected = !props.adminViewInfo
    ? (e: any, i: any) => {
      navigateThenRun(() => showPastFeedback(e, i), "/pastfeedback");
    }
    : props.AttemptedQuestionSelected;

  document.body.style.backgroundColor = "white";

  return (
    <>
      {!props.adminViewInfo && <Nav />}
      {props.adminViewInfo && 
      <AdminMemberInfoBreadCrumb
      name={props.adminViewInfo.studentName}
      goToMembers={props.adminViewInfo.goToMembers}/>}
      <div className={`flex-col ${props.adminViewInfo ? 'dashboardScreen-noBack': 'dashboardScreen'} items-center p-8`}>
        <br />
        <div className="flex self-start">
              <p className='text-2xl text-left font-bold'>Stats</p>
        </div>
        <div className="flex-col mb-5 p-1 w-[100%]">
          <div className="flex-col w-[100%] my-4 ">
            <div className="flex justify-between flex-wrap gap-y-2">
              {/* Fit three rectangles per row */}
              <div className="w-[31%] bg-whiteButton  rounded-lg shadow-md  mx-2 p-2  flex  justify-between">
                <div className="flex-col justify-start items-start" >
                  <p className="mb-2 text-xs">Questions Completed</p>
                  <p className='text-xl font-semibold'>{props.adminViewInfo ? props.adminViewInfo.studentInfo.interviewsCompleted: state.profileUser?.interviewsCompleted||0}</p>
                </div>
                <div className="grad p-2 mr-3 flex self-center">
                  <TaskAlt />
                </div>
              </div>
              <div className="w-[31%] rounded-lg shadow-md bg-whiteButton  mx-2 p-2  flex  justify-between">
                <div className="flex-col justify-start items-start" >
                  <p className="mb-2 text-xs">Average Interview Score</p>
                  <p className='text-xl font-semibold'>{(props.adminViewInfo ? props.adminViewInfo.studentInfo.avgInterviewScore : state.profileUser?.avgInterviewScore || 0).toFixed(1)}%</p>
                </div>
                <div className="grad p-2 mr-3 flex self-center">
                  <TimelineOutlined />
                </div>
              </div>
              <div className="w-[31%] bg-whiteButton rounded-lg shadow-md mx-2 p-2  flex justify-between">
                <div className="flex-col justify-start items-start" >
                  <p className="mb-2 text-xs">Stars Earned</p>
                  <p className='text-xl font-semibold'>{props.adminViewInfo ? props.adminViewInfo.studentInfo.totalStars : state.profileUser?.totalStars||0}</p>
                </div>
                <div className="grad p-2 mr-3 flex self-center">
                  <AutoAwesome />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {props.adminView && <p>{props.memberName}</p>} */}
        <div className="flex-col align-self-start self-start">
              <p className='text-2xl text-left font-bold'>Past Activity</p>
              <p className="mt-2 mb-4 text-customBlack">Select a Question attempt to See Past Feedback</p>
        </div >
        <div className="w-full flex flex-col gap-2 pt-[4px]">
          {getAttemptedQuestions()}
          </div>
        </div>
    </>
  );
}

export default HistoryScreen;
